import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import FaqCategoryPage from 'src/pages/AppWebviews/Faq/FaqCategoryPage';
import FaqContentPage from 'src/pages/AppWebviews/Faq/FaqContentPage';
import FaqIndexPage from 'src/pages/AppWebviews/Faq/FaqIndexPage';
import FaqSearchPage from 'src/pages/AppWebviews/Faq/FaqSearchPage';

const AppWebviewsRoutes: FC = () => {
  return (
    <Routes>
      <Route path="faq" element={<FaqIndexPage />} />
      <Route path="faq/category/:categoryId" element={<FaqCategoryPage />} />
      <Route path="faq/content/:faqSlug" element={<FaqContentPage />} />
      <Route path="faq/search" element={<FaqSearchPage />} />
    </Routes>
  );
};

export default AppWebviewsRoutes;
